import { render, staticRenderFns } from "./AdministrationCosts.vue?vue&type=template&id=2c0105f8"
import script from "./AdministrationCosts.vue?vue&type=script&lang=js"
export * from "./AdministrationCosts.vue?vue&type=script&lang=js"
import style0 from "./AdministrationCosts.vue?vue&type=style&index=0&id=2c0105f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports